import script from "./ElementLoader.vue?vue&type=script&lang=js"
export * from "./ElementLoader.vue?vue&type=script&lang=js"

import "./ElementLoader.vue?vue&type=style&index=0&id=b13f820c&lang=scss"

const __exports__ = script;

export default __exports__